import { useStore } from "react-admin";

// ADO 4855: the reviewer's choice of what the generated VR report PDF
// contains -- passed to the backend as `content` on viewVrReportSnapshot.
export type VrReportContentMode =
  | "results"
  | "results_with_portfolio"
  | "portfolio_only";

export const VR_REPORT_CONTENT_MODE_OPTIONS: Array<{
  value: VrReportContentMode;
  label: string;
}> = [
  { value: "results", label: "Results Report" },
  {
    value: "results_with_portfolio",
    label: "Results Report with Document Portfolio",
  },
  { value: "portfolio_only", label: "Document Portfolio Only" },
];

const VR_REPORT_CONTENT_MODE_STORE_KEY = "vrReportContentMode";
const DEFAULT_VR_REPORT_CONTENT_MODE: VrReportContentMode = "results";

// Remembers the reviewer's report-content preference (results / with
// portfolio / portfolio only) across sessions for this browser. react-admin's
// useStore already persists to localStorage app-wide (see ToggleBtn.tsx,
// MyLayout.tsx's switchSubscriberName) -- no bespoke storage needed here.
export const useVrReportContentMode = () =>
  useStore<VrReportContentMode>(
    VR_REPORT_CONTENT_MODE_STORE_KEY,
    DEFAULT_VR_REPORT_CONTENT_MODE
  );
